import { Popper, PopperProps } from '@nexelem/popper';
import { clsx } from 'clsx';
import { ForwardedRef, forwardRef, ReactNode, RefObject } from 'react';
import { Trans, useTranslation } from 'react-i18next';

type InputLabelProps = {
  readonly required?: boolean;
  readonly label: ReactNode;
  readonly helperText?: ReactNode;
  readonly openingElement?: ReactNode;
  readonly placement?: PopperProps['placement'];
  readonly className?: string;
  readonly labelClassName?: string;
  readonly ref?: RefObject<HTMLDivElement>;
  readonly isJumbo?: boolean;
};

export const InputLabel = forwardRef(
  (
    {
      label,
      required,
      helperText,
      openingElement,
      placement = 'bottom-start',
      className,
      labelClassName,
      isJumbo,
    }: InputLabelProps,
    ref: ForwardedRef<HTMLDivElement>,
  ) => {
    const { t } = useTranslation();

    const baseLabel = (
      <div className={clsx('flex gap-1', className)} ref={ref}>
        {required && <span className={clsx('text-icon-error', isJumbo ? 'text-t20-sb' : 'text-t14-sb')}>*</span>}
        <span className={clsx('text-text-secondary', isJumbo ? 'text-t20-sb' : 'text-t14-sb', labelClassName)}>
          {label}
        </span>
      </div>
    );
    if (helperText && openingElement) {
      return (
        <div className="flex items-center gap-2" ref={ref}>
          {baseLabel}
          <Popper content={<Trans t={t}>{helperText}</Trans>} openingElement={openingElement} placement={placement} />
        </div>
      );
    }

    return <div ref={ref}>{baseLabel}</div>;
  },
);

InputLabel.displayName = 'InputLabel';
